//import { useQuery } from '@tanstack/react-query';
//import { routeAdacter } from 'adapters';
//import { contextApp } from 'context';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
//import { routeService } from 'services';

export const useDemands = () => {
 //const { auth } = contextApp();
 const [showModal, setShowModal] = useState(false);
 const [category] = useState([]);
 const [open, setOpen] = useState(false);

 const treeviewItems = [
  {
   name: 'public',
   id: '1',
   children: [
    {
     name: 'assets',
     id: '2',
     children: [
      {
       name: 'falcon.png',
       id: '3',
       iconClass: 'text-success'
      }
     ]
    }
   ]
  }
 ];

 const ruta = useLocation();

 const handleCopy = () => {
  setShowModal(true);
 };

 /* useQuery({
  queryKey: ['routesCategory'],
  queryFn: () => routeService.getRoutesCategories(auth?.token, company),
  onSuccess: data => {
   setCategory(routeAdacter.categories(data));
  }
 }); */
 return {
  open,
  setOpen,
  treeviewItems,
  ruta,
  handleCopy,
  showModal,
  setShowModal,
  category
 };
};

export default useDemands;
